export function getDuration(seconds) {
  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: Math.floor(seconds % 60)
  };
}

export const mm = minutes => {
  return minutes < 10 ? `0${minutes}` : `${minutes}`;
};

export const ss = seconds => {
  return seconds < 10 ? `0${seconds}` : `${seconds}`;
};

export const hmmss = ({ hours, minutes, seconds }) => {
  return `${hours}:${mm(minutes)}:${ss(seconds)}`;
};

export const mss = ({ hours = 0, minutes, seconds }) => {
  const hoursToMinutes = hours * 60;
  minutes += hoursToMinutes;
  return `${minutes}:${ss(seconds)}`;
};

export function miniDuration(seconds) {
  const duration = getDuration(seconds);
  return duration.hours ? hmmss(duration) : mss(duration);
}

export function complexDuration(leftSeconds, rightSeconds) {
  const left = getDuration(leftSeconds);
  const right = getDuration(rightSeconds);
  return right.hours
    ? `${hmmss(left)} / ${hmmss(right)}`
    : `${mss(left)} / ${mss(right)}`;
}

export function complexDurationNoFraction(seconds) {
  const duration = getDuration(seconds);
  return `${mss(duration)}`;
}
// Convert to ISO 8601 for SEO Schemas. https://en.wikipedia.org/wiki/ISO_8601#Durations
export function getDurationISO8601(ms) {
  const durationInSeconds = ms / 1000;

  const { hours, minutes, seconds } = getDuration(durationInSeconds);

  const hourDisplay = hours ? `${hours}H` : "";
  const minuteDisplay = `${minutes}M`;
  const secondDisplay = `${seconds}S`;

  return `PT${hourDisplay}${minuteDisplay}${secondDisplay}`;
}

export function simpleDuration(seconds) {
  const duration = getDuration(seconds);
  return duration.hours
    ? `${duration.hours} hr ${duration.minutes} min`
    : duration.minutes
    ? `${duration.minutes} min`
    : `${duration.seconds} sec`;
}
